import { Select, TextInput } from "@msuite/ui/form";
import { getProtocolPriorityColor, getProtocolPriorityIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import {
	getProtocolPriorityCallbackTime,
	getProtocolPriorityTranslationKey,
} from "@msuite/utils/protocols";
import { type ProtocolFormSchema, protocolPriorityTypes } from "@msuite/utils/schemas";
import { capitalize } from "@msuite/utils/strings";
import { useFormContext, useWatch } from "react-hook-form";

export function ProtocolFormTypeCallRequestCallPriority() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const priority = useWatch({ control: methods.control, name: "callRequestDetails.priority" });

	/** Hooks */
	const { t } = useTranslation();

	/** Functions */
	function handleOnPriorityChange(priority: "custom" | "very-high" | "high" | "medium" | "low") {
		methods.setValue("callRequestDetails.callbackTime", getProtocolPriorityCallbackTime(priority));
	}

	/** Render */
	return (
		<div className="h-stack gap-4 items-start">
			<div>
				<Select
					className="w-[200px]"
					options={protocolPriorityTypes.map((priority) => ({
						label: capitalize(priority),
						value: priority,
						item: { priority },
					}))}
					isRequired
					renderOption={(option) => (
						<div className="h-stack">
							<Icon
								name={getProtocolPriorityIcon(option.priority)}
								color={`var(--color-${getProtocolPriorityColor(option.priority)}-500)`}
							/>
							<p>{t(getProtocolPriorityTranslationKey(option.priority))}</p>
						</div>
					)}
					isNullable={false}
					control={methods.control}
					name="callRequestDetails.priority"
					label={t("priority.priority")}
					itemNotFoundLabel={t("general.not_found")}
					middleware={handleOnPriorityChange}
				/>
			</div>
			{priority && (
				<TextInput
					control={methods.control}
					name="callRequestDetails.callbackTime"
					type="datetime-local"
					label={t("protocols.callback_time")}
					isRequired
					isDisabled={priority !== "custom"}
				/>
			)}
		</div>
	);
}
